/**
 * Created by ruslan on 11.07.17.
 */

const styles = {
  action: {
    'alignItems': 'center',
    'display': 'flex',
    'fontWeight': 'inherit',
    'textAlign': 'left',
    'color': '#03a9f4',
  },
  actionIcon: {
    'marginRight': 5
  }
};

export default styles;


// WEBPACK FOOTER //
// ./src/react-material-components-demo/styles/table.css.js